import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  TrialBalanceItem, Jaarrekening, Jaarrapportage, BalanceItem, FormattedExplanation, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-vastgoedbeleggingen',
  templateUrl: './spec-vastgoedbeleggingen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    CommonModule
  ],
  styleUrls: ['./spec-vastgoedbeleggingen.component.css']
})
export class SpecVastgoedbeleggingenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public investmentPropertiesFg = {} as FormGroup;
  public investmentPropertiesInExploitationFg = {} as FormGroup;
  public investmentPropertiesInDevelopmentFg = {} as FormGroup;
  public investmentPropertiesDisclosureFg = {} as FormGroup;
  public investmentPropertiesFairValueDisclosureFg = {} as FormGroup;
  public investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescriptionFg = {} as FormGroup;
  public investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescriptionFg = {} as FormGroup;
  public directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg = {} as FormGroup;
  public investmentPropertiesImpairmentDescriptionFg = {} as FormGroup;
  public criteriaFinishedPhaseRealEstateInDevelopmentDescriptionFg = {} as FormGroup;
  public investmentPropertiesImpairmentReversalDescriptionFg = {} as FormGroup;
  public rentalIncomeFromInvestmentPropertiesDisclosureFg = {} as FormGroup;
  public investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescriptionFg = {} as FormGroup;
  public investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescriptionFg = {} as FormGroup;
  public investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescriptionFg = {} as FormGroup;
  public investmentPropertiesMethodsAssumptionsToDetermineFairValueDescriptionFg = {} as FormGroup;
  public investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg = {} as FormGroup;
  public investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg = {} as FormGroup;
  public investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescriptionFg = {} as FormGroup;
  public investmentPropertiesInterestRateToDetermineFairValueDescriptionFg = {} as FormGroup;
  public investmentPropertiesInterestRateDeterminationConsiderationsDescriptionFg = {} as FormGroup;
  public investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescriptionFg = {} as FormGroup;
  public investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescriptionFg = {} as FormGroup;
  public investmentPropertiesDisposalsNotValuedAtFairValueDescriptionFg = {} as FormGroup;
  public investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescriptionFg = {} as FormGroup;
  public realEstateInExploitationDisclosureFg = {} as FormGroup;
  public realEstateInDevelopmentDisclosureFg = {} as FormGroup;
  public directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.investmentPropertiesFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();
    this.investmentPropertiesInExploitationFg = this.jrDataService.createFormGroupBalanceItem();
    this.investmentPropertiesInDevelopmentFg = this.jrDataService.createFormGroupBalanceItem();
    this.investmentPropertiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesFairValueDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesImpairmentDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.criteriaFinishedPhaseRealEstateInDevelopmentDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesImpairmentReversalDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.rentalIncomeFromInvestmentPropertiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesMethodsAssumptionsToDetermineFairValueDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesInterestRateToDetermineFairValueDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesInterestRateDeterminationConsiderationsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesDisposalsNotValuedAtFairValueDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.realEstateInExploitationDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.realEstateInDevelopmentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {
    const vastgoedbeleggingen = value.rapportage?.jaarrekeningen?.at(0)?.balans?.vastgoedbeleggingen;

    if (vastgoedbeleggingen) {
      this.investmentPropertiesFg.reset();

      if (vastgoedbeleggingen.investmentProperties) {
        this.investmentPropertiesFg.patchValue(vastgoedbeleggingen.investmentProperties, {emitEvent: false})
      }

      const uitsplitsing = vastgoedbeleggingen.vastgoedbeleggingenUitsplitsing;
      const tekstueel = vastgoedbeleggingen.vastgoedbeleggingenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.investmentPropertiesInExploitation) {
          const subItem = uitsplitsing.investmentPropertiesInExploitation;
          this.investmentPropertiesInExploitationFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.investmentPropertiesInExploitationFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.investmentPropertiesInDevelopment) {
          const subItem = uitsplitsing.investmentPropertiesInDevelopment;
          this.investmentPropertiesInDevelopmentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.investmentPropertiesInDevelopmentFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.investmentPropertiesDisclosure) {
          this.investmentPropertiesDisclosureFg.patchValue(tekstueel.investmentPropertiesDisclosure);
        }
        if (tekstueel.investmentPropertiesFairValueDisclosure) {
          this.investmentPropertiesFairValueDisclosureFg.patchValue(tekstueel.investmentPropertiesFairValueDisclosure);
        }
        if (tekstueel.investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescription) {
          this.investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescriptionFg.patchValue(tekstueel.investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescription);
        }
        if (tekstueel.investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescription) {
          this.investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescriptionFg.patchValue(tekstueel.investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescription);
        }
        if (tekstueel.investmentPropertiesImpairmentDescription) {
          this.investmentPropertiesImpairmentDescriptionFg.patchValue(tekstueel.investmentPropertiesImpairmentDescription);
        }
        if (tekstueel.criteriaFinishedPhaseRealEstateInDevelopmentDescription) {
          this.criteriaFinishedPhaseRealEstateInDevelopmentDescriptionFg.patchValue(tekstueel.criteriaFinishedPhaseRealEstateInDevelopmentDescription);
        }
        if (tekstueel.investmentPropertiesImpairmentReversalDescription) {
          this.investmentPropertiesImpairmentReversalDescriptionFg.patchValue(tekstueel.investmentPropertiesImpairmentReversalDescription);
        }
        if (tekstueel.rentalIncomeFromInvestmentPropertiesDisclosure) {
          this.rentalIncomeFromInvestmentPropertiesDisclosureFg.patchValue(tekstueel.rentalIncomeFromInvestmentPropertiesDisclosure);
        }
        if (tekstueel.directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosure) {
          this.directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg.patchValue(tekstueel.directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosure);
        }
        if (tekstueel.investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescription) {
          this.investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescriptionFg.patchValue(tekstueel.investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescription);
        }
        if (tekstueel.investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescription) {
          this.investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescriptionFg.patchValue(tekstueel.investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescription);
        }
        if (tekstueel.investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescription) {
          this.investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescriptionFg.patchValue(tekstueel.investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescription);
        }
        if (tekstueel.investmentPropertiesMethodsAssumptionsToDetermineFairValueDescription) {
          this.investmentPropertiesMethodsAssumptionsToDetermineFairValueDescriptionFg.patchValue(tekstueel.investmentPropertiesMethodsAssumptionsToDetermineFairValueDescription);
        }
        if (tekstueel.investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescription) {
          this.investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg.patchValue(tekstueel.investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescription);
        }
        if (tekstueel.investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescription) {
          this.investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg.patchValue(tekstueel.investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescription);
        }
        if (tekstueel.investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescription) {
          this.investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescriptionFg.patchValue(tekstueel.investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescription);
        }
        if (tekstueel.investmentPropertiesInterestRateToDetermineFairValueDescription) {
          this.investmentPropertiesInterestRateToDetermineFairValueDescriptionFg.patchValue(tekstueel.investmentPropertiesInterestRateToDetermineFairValueDescription);
        }
        if (tekstueel.investmentPropertiesInterestRateDeterminationConsiderationsDescription) {
          this.investmentPropertiesInterestRateDeterminationConsiderationsDescriptionFg.patchValue(tekstueel.investmentPropertiesInterestRateDeterminationConsiderationsDescription);
        }
        if (tekstueel.investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescription) {
          this.investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescriptionFg.patchValue(tekstueel.investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescription);
        }
        if (tekstueel.investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescription) {
          this.investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescriptionFg.patchValue(tekstueel.investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescription);
        }
        if (tekstueel.investmentPropertiesDisposalsNotValuedAtFairValueDescription) {
          this.investmentPropertiesDisposalsNotValuedAtFairValueDescriptionFg.patchValue(tekstueel.investmentPropertiesDisposalsNotValuedAtFairValueDescription);
        }
        if (tekstueel.investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescription) {
          this.investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescriptionFg.patchValue(tekstueel.investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescription);
        }
        if (tekstueel.realEstateInExploitationDisclosure) {
          this.realEstateInExploitationDisclosureFg.patchValue(tekstueel.realEstateInExploitationDisclosure);
        }
        if (tekstueel.realEstateInDevelopmentDisclosure) {
          this.realEstateInDevelopmentDisclosureFg.patchValue(tekstueel.realEstateInDevelopmentDisclosure);
        }
        if (tekstueel.directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosure) {
          this.directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg.patchValue(tekstueel.directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i], {emitEvent: false});
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup, {emitEvent: false});
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.investmentPropertiesFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesInExploitationFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesInDevelopmentFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesFairValueDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesImpairmentDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.criteriaFinishedPhaseRealEstateInDevelopmentDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesImpairmentReversalDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.rentalIncomeFromInvestmentPropertiesDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesMethodsAssumptionsToDetermineFairValueDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesInterestRateToDetermineFairValueDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesInterestRateDeterminationConsiderationsDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesDisposalsNotValuedAtFairValueDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.realEstateInExploitationDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.realEstateInDevelopmentDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          vastgoedbeleggingen: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.vastgoedbeleggingen,
            vastgoedbeleggingenUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.vastgoedbeleggingen?.vastgoedbeleggingenUitsplitsing,
              investmentPropertiesInExploitation: this.investmentPropertiesInExploitationFg.value,
              investmentPropertiesInDevelopment: this.investmentPropertiesInDevelopmentFg.value,
            },
            vastgoedbeleggingenTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.vastgoedbeleggingen?.vastgoedbeleggingenTekstueel,
              investmentPropertiesDisclosure: this.investmentPropertiesDisclosureFg.value,
              investmentPropertiesFairValueDisclosure: this.investmentPropertiesFairValueDisclosureFg.value,
              investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescription: this.investmentPropertiesExistenceOfLimitationsRegardingTheApplicationDescriptionFg.value,
              investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescription: this.investmentPropertiesExistenceOfLimitationsRegardingTheCollectabilityOfIncomeDescriptionFg.value,
              investmentPropertiesImpairmentDescription: this.investmentPropertiesImpairmentDescriptionFg.value,
              criteriaFinishedPhaseRealEstateInDevelopmentDescription: this.criteriaFinishedPhaseRealEstateInDevelopmentDescriptionFg.value,
              investmentPropertiesImpairmentReversalDescription: this.investmentPropertiesImpairmentReversalDescriptionFg.value,
              rentalIncomeFromInvestmentPropertiesDisclosure: this.rentalIncomeFromInvestmentPropertiesDisclosureFg.value,
              directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosure: this.directOperationalExpensesOfInvestmentPropertiesThatGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg.value,
              investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescription: this.investmentPropertiesContractualObligationsToPurchaseConstructOrDevelopInvestmentPropertyOrForRepairsMaintenanceOrEnhancementsDescriptionFg.value,
              investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescription: this.investmentPropertiesCircumstancesRightsOfUseAccountedAsInvestmentPropertyDescriptionFg.value,
              investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescription: this.investmentPropertiesCriteriaToDistinguishBetweenRealEstateForOwnUseDescriptionFg.value,
              investmentPropertiesMethodsAssumptionsToDetermineFairValueDescription: this.investmentPropertiesMethodsAssumptionsToDetermineFairValueDescriptionFg.value,
              investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescription: this.investmentPropertiesFairValueBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg.value,
              investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescription: this.investmentPropertiesFairValueNotBasedOnEstimateOfIndependentQualifiedExpertDescriptionFg.value,
              investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescription: this.investmentPropertiesOverviewOfAssumptionsToDetermineFairValueDescriptionFg.value,
              investmentPropertiesInterestRateToDetermineFairValueDescription: this.investmentPropertiesInterestRateToDetermineFairValueDescriptionFg.value,
              investmentPropertiesInterestRateDeterminationConsiderationsDescription: this.investmentPropertiesInterestRateDeterminationConsiderationsDescriptionFg.value,
              investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescription: this.investmentPropertiesValuedAtHistoricCostsAsFairValueCannotBeQuantifiedDescriptionFg.value,
              investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescription: this.investmentPropertiesReasonWhyFairValueCannotBeQuantifiedAndLikelyRangeOfFairValueDescriptionFg.value,
              investmentPropertiesDisposalsNotValuedAtFairValueDescription: this.investmentPropertiesDisposalsNotValuedAtFairValueDescriptionFg.value,
              investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescription: this.investmentPropertiesOwnDevelopmentCostsOtherIndirectCostsAndInterestIsTakenIntoAccountDescriptionFg.value,
              realEstateInExploitationDisclosure: this.realEstateInExploitationDisclosureFg.value,
              realEstateInDevelopmentDisclosure: this.realEstateInDevelopmentDisclosureFg.value,
              directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosure: this.directOperationalExpensesOfInvestmentPropertiesThatDidNotGeneratedRentalIncomeDuringTheReportingPeriodDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}
